<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col align="center" cols="6" md="2">
        <router-link :to="`/transactions`">
          <v-icon color="#066a8c">mdi-chart-bar</v-icon>
          <div class="mnuBtn btn_bg">Analytics</div>
        </router-link>
      </v-col>

      <v-col align="center" cols="6" md="2">
        <router-link :to="`/online-wallet`">
          <v-icon color="#066a8c">mdi-wallet</v-icon>
          <div class="mnuBtn">Online Wallets</div>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" lg="1"></v-col>
      <v-col sm="12" lg="7" style="text-align: center; min-height: 60px">
      </v-col>
    </v-row>
    <!-- <v-row>
      <transaction-data></transaction-data>
    </v-row>

    <v-row>
      <v-col sm="12" lg="1"> <v-spacer></v-spacer></v-col>
    </v-row> -->

    <v-row>
      <qube-transaction-data></qube-transaction-data>
    </v-row>
    <v-row>
      <krews-qube-transaction-data></krews-qube-transaction-data>
    </v-row>
    <v-row>
      <qode-fee-graph></qode-fee-graph>
    </v-row>
    <v-row>
      <krews-payment-gateway-fees-data></krews-payment-gateway-fees-data>
    </v-row>
    <v-row>
      <krews-payment-gateway-revenue-data></krews-payment-gateway-revenue-data>
    </v-row>
    <v-row>
      <qode-revenue-graph></qode-revenue-graph>
    </v-row>
    <v-row>
      <krews-payment-gateway-settled-graph></krews-payment-gateway-settled-graph>
    </v-row>
    <v-row>
      <krews-mobile-transaction-data></krews-mobile-transaction-data>
    </v-row>
  </v-container>
</template>

<script>
//import TransactionData from "@/components/Chart/TransactionsGraph";
import QubeTransactionData from "@/components/Chart/QubeTransactionsGraph";
import KrewsMobileTransactionData from "@/components/Chart/KrewsMobileTransactionsGraph";
import KrewsQubeTransactionData from "@/components/Chart/KrewsQubeTransactionsGraph";
import KrewsPaymentGatewayFeesData from "@/components/Chart/KrewsPaymentGatewayFeesGraph";
import KrewsPaymentGatewayRevenueData from "@/components/Chart/KrewsPaymentGatewayRevenueGraph";
import KrewsPaymentGatewaySettledGraph from "../../components/Chart/KrewsPaymentGatewaySettledGraph.vue";
import QodeFeeGraph from "../../components/Chart/QodeFeeGraph.vue";
import QodeRevenueGraph from "../../components/Chart/QodeRevenue.vue";
export default {
  components: {
    // TransactionData,
    QubeTransactionData,
    KrewsMobileTransactionData,
    KrewsQubeTransactionData,
    KrewsPaymentGatewayFeesData,
    KrewsPaymentGatewayRevenueData,
    KrewsPaymentGatewaySettledGraph,
    QodeFeeGraph,
    QodeRevenueGraph,
  },
  mounted() {
    setTimeout(() => {
      this.btnShow = true;
    }, 10);
  },
};
</script>

<style scoped>
.ptBtn {
  padding: 5px;
  font-size: 14px;
  font-weight: bold;
  color: #066a8c;
}
.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
</style>
